export default "__VITE_ASSET__CM0xy20X__"